import { formatCurrency, formatNumber } from "@angular/common"
import { Component, Inject, Input, LOCALE_ID } from "@angular/core"
import { NODE_TYPE } from "../../common/linqset-model"
import { v4 } from "uuid"
import { Currency, DEFAULT_CURRENCY, getCurrency } from "../../common/organisation"
import { OrganisationService } from "../../organisation/organisation.service"

export enum INSIGHT_VALUE_TYPE {
    CURRENCY,
    NUMBER,
    PERCENTAGE
}

export class InsightCard { 
    key:string      // used as unique key for for loop
    change:number
    icon:string
    image:string
    changeColour:string
    public units:string

    constructor(public title:string, public type:NODE_TYPE, public tooltip:string, public text:string=null, public value:number=null, public csValue:number=null, public valueType:INSIGHT_VALUE_TYPE=INSIGHT_VALUE_TYPE.NUMBER, public total?:number) {
        this.key = v4()
        if (this.hasComparison) {
            this.change = Math.round(100*((this.value-this.csValue)/this.csValue))
            if (this.change == 0) this.changeColour = "orange"
            if (this.change > 0) this.changeColour = "green"
            if (this.change < 0) this.changeColour = "red"
        }        
    }

    get changePercentage() {
        
        if (this.change > 1000) {
            return Math.round(this.change/1000) + 'k%'
        }else return this.change + '%'
    }

    get percentage() {
        if (this.valueType === INSIGHT_VALUE_TYPE.PERCENTAGE) return this.value
        if (this.total) return Math.round(100*this.value/this.total)
        return 0
    }

    get hasComparison() {
        return this.csValue
    }

    getValueToDisplay(locale:string, currency?:Currency) {
        return (this.text !== null)?this.text:this.getFormattedValue(this.value, locale, currency)
    }

    getFontColour() {
        if (this.value < 0) return 'color:#b42318'
        return ''
    }

    getChangeValueToDisplay(locale:string, currency?:Currency) {
        return this.csValue && this.getFormattedValue(this.csValue, locale, currency)
    }

    private getFormattedValue(value:number, locale:string, currency?:Currency) {
        switch (this.valueType) {
            case INSIGHT_VALUE_TYPE.CURRENCY:
                return formatCurrency(value, locale, currency?.symbol||'$', currency?.code||'NZD', '1.0-2')
            case INSIGHT_VALUE_TYPE.NUMBER:
                return formatNumber(value, locale)
            case INSIGHT_VALUE_TYPE.PERCENTAGE:
                return value + "%"
        }
    }
}

@Component({
    selector: 'app-insight-cards',
    templateUrl: './insight-cards.html',
    styleUrls: ['./insight-cards.scss'],
    standalone: false
})
export class InsightCardsComponent {
    @Input() cards:InsightCard[]

    currency:Currency
    INSIGHT_VALUE_TYPE=INSIGHT_VALUE_TYPE

    constructor(@Inject(LOCALE_ID) public locale: string, organisationService:OrganisationService) {
        this.currency = getCurrency(organisationService.organisation?.currencyCode||DEFAULT_CURRENCY)
    }

}